import { Schema } from '@guiker/real-estate-shared'
import { TypeOf, yup } from '@guiker/shared-framework'

export const updateSeriesFinancialInfoFinancialsSchema = yup.object({
  financialInfo: yup.object({ financials: Schema.financials }).required(),
})

export type UpdateSeriesFinancialInfoFinancials = TypeOf<typeof updateSeriesFinancialInfoFinancialsSchema>
